import uniqBy from 'lodash/uniqBy';
import pickBy from 'lodash/pickBy';

export const mapAppSubscriptions = (
  organisationId,
  communityAppId,
  existingApp,
  body,
  feature
) => ({
  organisation: { id: organisationId },
  communityApp: {
    id: communityAppId,
    communityAppFeatures: body
      ? uniqBy(
          [
            {
              appInstallationFeature: { tag: body.appInstallationFeature.tag },
              appFeatureSubscription: pickBy(
                {
                  validFrom: body.communityAppFeatureSubscription?.validFrom,
                  validUntil: body.communityAppFeatureSubscription?.validUntil,
                },
                v => v !== null && v !== undefined && v !== ''
              ),
            },
            ...(existingApp?.communityAppFeatures || [])
              .filter(f => f.requiresSubscription && f.appInstallationFeature?.tag !== body.tag)
              .map(f => ({
                appInstallationFeature: { tag: f.appInstallationFeature?.tag },
                appFeatureSubscription: pickBy(
                  {
                    validFrom: f.communityAppFeatureSubscription?.validFrom,
                    validUntil: f.communityAppFeatureSubscription?.validUntil,
                  },
                  v => v !== null && v !== undefined && v !== ''
                ),
              })),
          ],
          'appInstallationFeature.tag'
        )
      : (existingApp?.communityAppFeatures || [])
          .filter(f => f.appInstallationFeature?.tag !== feature?.appInstallationFeature?.tag)
          .filter(f => f.requiresSubscription)
          .map(({ communityAppFeatureSubscription, ...ca }) => ({
            ...ca,
            appFeatureSubscription: communityAppFeatureSubscription,
          })),
  },
});
